import { render, staticRenderFns } from "./Gszx.vue?vue&type=template&id=4f867113&scoped=true&"
import script from "./Gszx.vue?vue&type=script&lang=js&"
export * from "./Gszx.vue?vue&type=script&lang=js&"
import style0 from "./Gszx.vue?vue&type=style&index=0&id=4f867113&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f867113",
  null
  
)

export default component.exports